"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtPhoneNumbers = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtPhoneNumbers = function SvgBtPhoneNumbers(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.064 4.96h-9.91c-.816 0-1.476.692-1.476 1.54v1.46H7.36a.407.407 0 00-.399.415c0 .228.177.415.399.415h.32v2.92h-.32a.407.407 0 00-.399.415c0 .228.177.415.399.415h.32v2.92h-.32a.407.407 0 00-.399.415c0 .228.177.415.399.415h.32v2.92h-.32a.407.407 0 00-.399.415c0 .228.177.415.399.415h.32v1.46c0 .848.66 1.54 1.475 1.54h9.91c.816 0 1.476-.692 1.476-1.54v-15c0-.848-.66-1.54-1.476-1.54zm.678 16.54c0 .393-.306.71-.678.71h-9.91c-.372 0-.678-.317-.678-.71v-1.46h.32a.407.407 0 00.398-.415.407.407 0 00-.399-.415h-.319v-2.92h.32a.407.407 0 00.398-.415.407.407 0 00-.399-.415h-.319v-2.92h.32a.407.407 0 00.398-.415.407.407 0 00-.399-.415h-.319V8.79h.32a.407.407 0 00.398-.415.407.407 0 00-.399-.415h-.319V6.5c0-.393.306-.71.678-.71h9.91c.372 0 .678.317.678.71v15z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.08
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.975 14.04c1.056 0 1.915-.86 1.915-1.915 0-1.056-.859-1.915-1.915-1.915s-1.915.86-1.915 1.915c0 1.056.86 1.915 1.915 1.915zm0-3a1.086 1.086 0 010 2.17 1.086 1.086 0 010-2.17zM11.791 15.795l.02.034c.516-.304 1.308-.664 2.164-.664.856 0 1.648.36 2.164.664.253.15.421.468.421.813v.24a.125.125 0 01-.017.067.074.074 0 01-.008.01h-5.12a.067.067 0 01-.008-.01.125.125 0 01-.017-.066v-.24c0-.346.168-.664.421-.814l-.02-.034zm0 0c.518-.306 1.318-.67 2.184-.67.866 0 1.666.364 2.184.67h-4.368zm4.77-.68h0c-.602-.355-1.54-.78-2.586-.78-1.045 0-1.984.425-2.585.78h0c-.513.302-.83.888-.83 1.527v.24c0 .498.375.908.844.908h5.143c.468 0 .843-.41.843-.907v-.24c0-.64-.316-1.226-.83-1.529z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.08
  }));
};

exports.SvgBtPhoneNumbers = SvgBtPhoneNumbers;